import { FormControlTextInput } from '../form-control-text-input';
import { IconAccount } from '../icon';

import { MaskInputProps } from '.';

export const EMAIL_INPUT_ACCESSORY_ID = 'emailMaskedInput';

export function NameInput(props: MaskInputProps) {
  return (
    <FormControlTextInput
      style={{ maxHeight: 48 }}
      error={props.error ? 'Please enter a valid name' : ''}
      label={'Name'}
      placeholder={'Enter Your Name'}
      keyboardType="default"
      leftIcon={<IconAccount size={24} />}
      onChangeText={props.onChange}
      value={props.value}
      autoFocus={props.autoFocus}
    />
  );
}
